//export const Base_URL = "http://192.168.29.242:5090/api";
// export const Base_URL="http://192.168.29.175:5090/api";
//export const Base_URL="http://192.168.29.93:5090/api";
// FOR DEVELOPMENT SERVER
//export const Base_URL="http://192.168.29.93:7039/api";

//    export const Base_URL="http://192.168.29.93:5090/api";
// FOR QUALITY SERVER

// export const Base_URL = "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/api";

// export const Base_URL = "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/api";

// export const Base_URL="https://expensemanagement20250407171557.azurewebsites.net/api";

//export const Base_URL="http://192.168.29.29:5090/api";

// export const Base_URL="https://localhost:7039/api";

// //export const Base_URL="https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/api";
// export const Base_URL="https://expensemanagement20250407171557.azurewebsites.net/api";

// // For Development

// // For Development
//  export const Base_URL = "http://localhost:5090/api";

// export const Base_URL = "http://192.168.1.2:5090/api";
// export const tempURl = "http://192.168.1.2:5090";
// export const windowURL = "http://192.168.1.2:5090/auth/Logins";

// export const Base_URL = "http://192.168.29.15:5090/api";
// export const tempURl = "http://192.168.29.15:5090";
// export const windowURL = "http://192.168.29.15:5090/auth/Logins";

// export const Base_URL = "http://192.168.29.14:5090/api";
// export const tempURl = "http://192.168.29.14:5090";
// export const windowURL = "http://192.168.29.14:5090/auth/Login";

// For Development

//  export const Base_URL = "http://192.168.29.76:5090/api";
//  export const tempURl = "http://192.168.29.243:5090/";
//  export const windowURL = "http://192.168.29.243:5090/auth/Login";


// export const Base_URL = "https://192.168.1.38:7039/api";

// export const Base_URL = "https://192.168.29.101:7039/api";
// export const Base_URL2 = "http://192.168.29.101:5091/api";
// export const tempURl = "https://192.168.29.101:7039";
// export const windowURL = "https://192.168.29.101:7039/auth/Login";

// export const Base_URL = "https://localhost:7039/api";

// export const Base_URL2 = "http://192.168.1.38:5091/api";
// export const tempURl = "https://192.168.1.38:7039";
// export const windowURL = "https://192.168.1.38:7039/auth/Login";

// For Production
export const Base_URL =
  "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/api";
export const Base_URL2 =
  "https://mavrobackend3-bxcvd8fuesdbeegk.centralindia-01.azurewebsites.net/api";
export const tempURl =
  "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net";
export const windowURL =
  "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/auth/Login";

// For Development
// export const tempURl = "https://localhost:7039";

// For Development

// For Production
// export const windowURL = "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/auth/Login";
